import SubscriptionPreferences from '@pages/SubscriptionPreferences';
import UnsubscribeGroup from '@pages/UnsubscribeGroup';
import { type RouteObject } from 'react-router';

const UNSUBSCRIBE_ROUTES: RouteObject[] = [
    {
        path: '/subscription-preferences/channel',
        element: <SubscriptionPreferences />,
    },
    {
        path: '/subscription-preferences',
        element: <SubscriptionPreferences />,
    },
    {
        path: '/unsubscribe',
        element: <UnsubscribeGroup />,
    },
];

export default [...UNSUBSCRIBE_ROUTES];
